import { MatDialogConfig } from "@angular/material/dialog";
import { ConfirmDialogData } from "../shared/dialogs/confirm-dialog/confirm-dialog.component";

export const DELETE_COMPETITORS_DIALOG_CONFIG: MatDialogConfig<ConfirmDialogData> =
  {
    data: {
      title: "Delete Competitors",
      message: "Do you want to delete this Competitors?",
      inputForm: [],
    },
  };
